import React, { useState } from 'react'
import { Button, Glyphicon } from 'react-bootstrap'

type Props = { addTerminal: Function }

const AddTerminalBox = ({ addTerminal }: Props) => {
  const [company, setCompany] = useState('')
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [area, setArea] = useState('')
  const [code, setCode] = useState('')
  const [zip, setZip] = useState('')
  const [notes, setNotes] = useState('')
  const [password, setPassword] = useState('')

  return (
    <div style={{ background: '#fff', marginBottom: 20, padding: 7 }}>
      <input className="change-input form-control" placeholder="Företag *" value={company} onChange={(e) => setCompany(e.target.value)} type="text" />
      <input className="change-input form-control" placeholder="Förnamn & Efternamn *" value={name} onChange={(e) => setName(e.target.value)} type="text" />
      <input className="change-input form-control" placeholder="Email *" value={email} onChange={(e) => setEmail(e.target.value.trim())} type="email" />
      <input className="change-input form-control" placeholder="Tel" value={phone} onChange={(e) => setPhone(e.target.value)} type="email" />
      <input className="change-input form-control" placeholder="Kod (ex. IATA)" value={code} onChange={(e) => setCode(e.target.value)} type="text" />
      <input className="change-input form-control" placeholder="Område" value={area} onChange={(e) => setArea(e.target.value)} type="text" />
      <input className="change-input form-control" placeholder='Postnummer. Ex. "1" eller "16" ger tillgång till alla områden som börjar med "1" respektive "16"' value={zip} onChange={(e) => setZip(e.target.value)} type="text" />
      <input className="change-input form-control" placeholder="Anteckningar" value={notes} onChange={(e) => setNotes(e.target.value)} type="text" />
      <input className="change-input form-control" placeholder="Lösenord *" value={password} onChange={(e) => setPassword(e.target.value)} type="text" />
      <Button
        disabled={!company || !name || !email || !password}
        onClick={() => {
          addTerminal({
            company,
            name,
            email,
            phone,
            code,
            area,
            zip,
            notes,
            password: password && password,
          }).then((data) => {
            if (!data.isAxiosError) {
              setCompany('')
              setName('')
              setCode('')
              setEmail('')
              setPhone('')
              setArea('')
              setZip('')
              setPassword('')
            }
          })
        }}
        className="btn btn-primary"
        bsSize="small"
        style={{ backgroundColor: '#006e78' }}
        block
      >
        <Glyphicon glyph="glyphicon glyphicon-pencil" /> &nbsp; Spara åkeri
      </Button>
    </div>
  )
}

export default AddTerminalBox
